import { Extension } from "@tiptap/core";
import { CellSelection, TableMap } from "prosemirror-tables";

/**
 * 표 셀에 포커스(커서/선택)가 있을 때 **Ctrl/Cmd+A로 표 전체(모든 셀)를 선택**하는 확장.
 *
 * 기본 Mod-a는 문서 전체를 선택하지만, 표 안에서는 먼저 표 전체를 선택하는 편이
 * 사용성이 좋다(셀 일괄 색/정렬/삭제 등). 동작:
 *  - 셀 안인데 표 전체가 아직 선택되지 않음 → 표 전체 CellSelection (handled)
 *  - 이미 표 전체가 선택됨 → false 반환 → 기본 동작(문서 전체 선택)으로 단계적 확장
 *  - 표 밖 → false (기본 문서 전체 선택)
 *
 * priority를 높여 기본 selectAll보다 먼저 처리한다.
 */
export const TableSelectAllExtension = Extension.create({
  name: "lumirTableSelectAll",
  priority: 1000,

  addKeyboardShortcuts() {
    return {
      "Mod-a": () => {
        const view = this.editor.view;
        const { state } = view;
        const sel: any = state.selection;
        const $from = sel.$from;

        // 선택을 감싸는 table 노드의 depth를 찾는다.
        let depth = -1;
        for (let d = $from.depth; d > 0; d--) {
          if ($from.node(d).type.name === "table") {
            depth = d;
            break;
          }
        }
        if (depth < 0) return false; // 표 밖 → 기본 동작

        const table = $from.node(depth);
        const tableStart = $from.start(depth);
        const map = TableMap.get(table);
        const firstRel = map.map[0]; // 좌상단 셀
        const lastRel = map.map[map.map.length - 1]; // 우하단 셀

        // 이미 표 전체가 선택돼 있으면 기본 동작(문서 전체)로 넘긴다.
        if (sel instanceof CellSelection) {
          const a = sel.$anchorCell.pos - tableStart;
          const h = sel.$headCell.pos - tableStart;
          if (Math.min(a, h) === firstRel && Math.max(a, h) === lastRel) {
            return false;
          }
        }

        const tr = state.tr.setSelection(
          CellSelection.create(
            state.doc,
            tableStart + firstRel,
            tableStart + lastRel,
          ),
        );
        view.dispatch(tr);
        return true;
      },
    };
  },
});
